import { useContext } from "react";

import { CurrenciesContext } from "../contexts/CurrenciesContext";

export const useCurrencies = () => {
  return useContext(CurrenciesContext);
};